const DISABLE_CLASS = 'gf-disabled_action';

export const  disableNavBarAction = () => {
  const navBar = document.getElementById('divTopBar');
  if (!navBar) {
    return;
  }

  navBar.querySelector('#gf-save')?.classList.add(DISABLE_CLASS);
  navBar.querySelector('#gf-preview')?.classList.add(DISABLE_CLASS);
  navBar.querySelector('#gf-publish')?.classList.add(DISABLE_CLASS);
  navBar.querySelector('#gf-upgrade')?.classList.add(DISABLE_CLASS);
}

export const enableNavBarAction = () => {
  const navBar = document.getElementById('divTopBar');
  if (!navBar) {
    return;
  }

  navBar.querySelector('#gf-save')?.classList.remove(DISABLE_CLASS);
  navBar.querySelector('#gf-preview')?.classList.remove(DISABLE_CLASS);
  navBar.querySelector('#gf-publish')?.classList.remove(DISABLE_CLASS);
  navBar.querySelector('#gf-upgrade')?.classList.remove(DISABLE_CLASS);
}

